const t = {
  name: "Upload",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13 6.41427L16.0001 9.41437L17.4143 8.00015L12.0001 2.58594L6.58588 8.00015L8.00009 9.41436L11 6.41446L11 17.0002H13L13 6.41427Z" fill="currentColor"/>
<path d="M4 15.0002V18.0002C4 18.5525 4.44772 19.0002 5 19.0002H19C19.5523 19.0002 20 18.5525 20 18.0002V15.0002H22V18.0002C22 19.657 20.6569 21.0002 19 21.0002H5C3.34315 21.0002 2 19.657 2 18.0002V15.0002H4Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Upload
};
